import {useLocation} from 'react-router-dom';
import './applicationConfirmation.css';
import Checkmark from '../images/checkmark.png'; 

function ApplicationConfirmation() {
    const { state } = useLocation();

    const faamsApp = state?.faamsApp ?? false;

    return (
        <div className="a-confirmation-page">
            <div className='a-confirmation-card'>
                {faamsApp ? (
                <>
                    <h1>Application Submitted Successfully!</h1>
                    <img src={Checkmark} alt="Checkmark" className="checkmark" />
                    <p>Thank you for applying for the FAAMS Scholarship. 
                        <br></br><br></br>
                        Your application has been successfully received and is now under review by our selection committee.</p>
                </>
                ):(
                <>
                    <h1>Congratulations On Your Submission!</h1>
                    <img src={Checkmark} alt="Checkmark" className="checkmark" />
                    <p>We have added your submission to your applications within your profile!</p>
                </>
                )};
            </div>
        </div>
    );
}

export default ApplicationConfirmation;